import React from 'react';
import { ArrowLeftIcon, SearchIcon, BellIcon, UserIcon, ChevronDownIcon, CalendarIcon, BarChart3Icon, HelpCircleIcon } from 'lucide-react';
export function Header({
  title = 'Warehouse',
  hasBackButton = true,
  hasCreateButton = true,
  createButtonText = 'Create warehouse',
  onCreateClick,
  icon = null,
  subtitle = 'Manage warehouse inventory and details'
}) {
  return <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-3108">
      <div className="px-6 py-4 flex justify-between items-center" data-id="element-3109">
        <div className="flex items-center" data-id="element-3110">
          {hasBackButton && <ArrowLeftIcon className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" size={20} data-id="element-3111" />}
          <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-3112">
            {icon || <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-3113">
                <path d="M6 19h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" data-id="element-3114"></path>
                <path d="M12 4v4" data-id="element-3115"></path>
                <path d="M3 10h18" data-id="element-3116"></path>
                <path d="M6 14h.01" data-id="element-3117"></path>
                <path d="M6 18h.01" data-id="element-3118"></path>
                <path d="M13 14h5" data-id="element-3119"></path>
                <path d="M13 18h5" data-id="element-3120"></path>
              </svg>}
          </div>
          <div data-id="element-3121">
            <h1 className="text-xl font-bold text-white" data-id="element-3122">{title}</h1>
            <p className="text-blue-200 text-sm hidden sm:block" data-id="element-3123">{subtitle}</p>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-3124">
          <div className="relative hidden sm:block" data-id="element-3125">
            <div className="relative" data-id="element-3126">
              <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-3127" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-3128" />
            </div>
          </div>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3129">
            <CalendarIcon size={20} data-id="element-3130" />
          </button>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3131">
            <BarChart3Icon size={20} data-id="element-3132" />
          </button>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3133">
            <HelpCircleIcon size={20} data-id="element-3134" />
          </button>
          <div className="relative" data-id="element-3135">
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3136">
              <BellIcon size={20} data-id="element-3137" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-3138">
                2
              </span>
            </button>
          </div>
          <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-3139">
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-3140">
              <UserIcon size={16} className="text-white" data-id="element-3141" />
            </div>
            <span className="text-white text-sm font-medium hidden sm:block" data-id="element-3142">
              Daniel Alejandro
            </span>
            <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-3143" />
          </div>
          {hasCreateButton && <button onClick={onCreateClick} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg" data-id="element-3144">
              {createButtonText}
            </button>}
        </div>
      </div>
    </header>;
}